export default (searchPath, searchKey) => {
  const path = searchPath.split('?')[1] || '';
  const variables = path.split('&');
  if (variables.length === 0) return '';
  for (let i = 0; i < variables.length; i += 1) {
    const [key, value] = variables[i].split('=');
    if (searchKey === key) return decodeURIComponent(value);
  }
  return '';
};



// WEBPACK FOOTER //
// ./src/common/extractSearchParams.js